import { FC, useState, useMemo } from "react"
import "./progress-steps.scss"

import { IProps, ISteps } from "./interfaces"
import Steps from "./Steps"

//currentStep is needed for info about where we are now
const Stepper: FC<IProps> = ({
  variant = "horizontal",
  stepNameArr,
  currentStep
}) => {
  const [stepState, setStepState] = useState<ISteps[]>([])

  useMemo(() => {
    let createSteps: ISteps[] = stepNameArr.map(
      (step: string | number, index: number) => {
        return {
          description: step,
          completed: index < currentStep - 1, // past are completed
          selected: index <= currentStep - 1, // past & present are colored
          active: index === currentStep - 1, // only present is active
          number: index + 1
        }
      }
    )
    setStepState(createSteps)
  }, [stepNameArr, currentStep])

  return (
    <ul className={`ocs-step-container ${variant}`}>
      {stepState.map((step: ISteps) => (
        <Steps
          key={step.number}
          description={step.description}
          completed={step.completed}
          selected={step.selected}
          active={step.active}
          number={step.number}
        />
      ))}
    </ul>
  )
}

export default Stepper
